import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MediaLibraryFileModel } from 'src/app/models/sales-funnel';
import { formatFileSize } from '../utils';

@Component({
  selector: 'app-media-library-view-informative-item',
  templateUrl: './media-library-view-informative-item.component.html',
  styleUrl: './media-library-view-informative-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaLibraryViewInformativeItemComponent {
  @Input() item: MediaLibraryFileModel;
  @Input() view: boolean = false;
  
  @Output() onRemove: EventEmitter<MediaLibraryFileModel> = new EventEmitter<MediaLibraryFileModel>();

  constructor() {}

  get formattedSize(): string {
    return this.item?.fileInfo?.size
      ? formatFileSize(this.item.fileInfo.size)
      : '0 B';
  }

  get fileTypeLabel(): string {
    const type = this.item?.fileInfo?.mimetype || '';
    if (!type) return 'Unknown';

    if (type.startsWith('image/')) return 'Image';
    if (type.startsWith('video/')) return 'Video';
    if (type.startsWith('audio/')) return 'Audio';

    if (type === 'application/pdf' || type.includes('pdf')) return 'PDF';

    if (
      type.includes('msword') ||
      type.includes('officedocument.wordprocessingml')
    )
      return 'Word Document';
    if (
      type.includes('spreadsheetml') ||
      type.includes('csv') ||
      type.includes('excel')
    )
      return 'Spreadsheet';
    if (type.includes('presentationml')) return 'Presentation';

    if (type === 'application/zip' || type === 'application/x-zip-compressed')
      return 'Archive';

    if (type.startsWith('text/') && type !== 'application/pdf')
      return 'Text Document';

    if (
      type.includes('json') ||
      type.includes('xml') ||
      type.includes('javascript') ||
      type.includes('typescript')
    )
      return 'Code';
    if (
      type.includes('chart') ||
      type.includes('data') ||
      type.includes('statistics')
    )
      return 'Data File';

    return 'File';
  }

  downloadFile(url: string) {
    window.open(url, '_blank');
  }

  previewFile() {
    if (this.item?.url) {
      window.open(this.item.url, '_blank');
    }
  }

  removeFile() {
    this.onRemove.emit(this.item);
  }
}
